import React from "react";

const Spinner = ({ message = "Loading..." }) => (
  <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex flex-col justify-center items-center z-50">
    
    <div className="w-14 h-14 border-4 border-blue-800 border-t-blue-400 rounded-full animate-spin"></div>

    <p className="text-blue-100 text-sm font-medium mt-4 select-none">
      {message}
    </p>
  </div>
);

export default Spinner;
